import { List } from "immutable";
import { isNil } from "lodash";

import checkboxStates from "../../constants/checkboxStates";
import { definitionSelectors } from "../../modules/definition";
import { uiStateSelectors } from "../../modules/uiState";
import { nativeCommsBroadcastMessageTypes } from "../../nativeComms";
import nativeCommsMessageTypes from "../../nativeComms/nativeCommsMessageTypes";
import { filterReadonlyMenus } from "../../utils/codeSplit";
import { WINDOWS_KEY_LABEL_CONTROL as keyCtrl, WINDOWS_KEY_LABEL_SHIFT as keyShift } from "./constants";
import readonlyFileMenu from "./readonlyMenuItems/readonlyFileMenus";
import toMenuItemRecord from "./toMenuItemRecord";
import { getShortCutString } from "./utils";

const exportMenu = (state, disabledItems) => {
  return List([
    {
      label: "CSV/TSV...",
      messageType: nativeCommsMessageTypes.FILE_EXPORT_CSV,
      disabled: false
    },
    {
      label: "PDF/Image...",
      messageType: nativeCommsMessageTypes.FILE_EXPORT_IMAGE,
      disabled: false
    },
    {
      label: "Timeline Standard (TSF)",
      messageType: nativeCommsMessageTypes.FILE_EXPORT_TSF
    }
  ]).map(item => toMenuItemRecord(item, disabledItems));
};

const convertLinksMenu = (state, disabledItems) => {
  const disabled = isNil(uiStateSelectors.getFileName(state)) || state.welcome.isVisible;
  const isRelative = definitionSelectors.getStoreRelativePaths(state);
  return List([
    {
      label: "Absolute Paths",
      messageType: nativeCommsMessageTypes.STORE_LINKS_AS_ABSOLUTE,
      state: state.welcome.isVisible
        ? checkboxStates.UNCHECKED
        : isRelative
          ? checkboxStates.UNCHECKED
          : checkboxStates.CHECKED,
      disabled
    },
    {
      label: "Relative Paths",
      messageType: nativeCommsMessageTypes.STORE_LINKS_AS_RELATIVE,
      state: state.welcome.isVisible
        ? checkboxStates.UNCHECKED
        : isRelative
          ? checkboxStates.CHECKED
          : checkboxStates.UNCHECKED,
      disabled
    }
  ]).map(item => toMenuItemRecord(item, disabledItems));
};

const recentFilesMenu = (state, disabledItems) => {
  return state.welcome.recentFiles
    .map((file, index) =>
      toMenuItemRecord(
        {
          label: `${file.displayPath}/${file.name}`,
          value: file.fullPath,
          hasSeparator: index >= state.welcome.recentFiles.size - 1,
          messageType: nativeCommsBroadcastMessageTypes.FILE_OPEN_RECENT
        },
        disabledItems
      )
    )
    .push(
      toMenuItemRecord(
        {
          label: "Clear Recent Files",
          messageType: nativeCommsBroadcastMessageTypes.FILE_CLEAR_RECENT,
          disabled: state.welcome.recentFiles.size === 0
        },
        disabledItems
      )
    );
};

export default (state, disabledItems) => {
  return filterReadonlyMenus(
    readonlyFileMenu,
    List([
      {
        label: "New",
        messageType: nativeCommsBroadcastMessageTypes.FILE_NEW,
        shortcut: getShortCutString([keyCtrl, keyShift, "N"]),
        disabled: false
      },
      {
        label: "Open",
        messageType: nativeCommsBroadcastMessageTypes.FILE_OPEN,
        shortcut: getShortCutString([keyCtrl, "O"]),
        disabled: false
      },
      {
        label: "Open Recent",
        messageType: "openRecent",
        hasSeparator: true,
        children: recentFilesMenu(state, disabledItems)
      },
      {
        label: "Close",
        messageType: nativeCommsBroadcastMessageTypes.FILE_CLOSE,
        shortcut: getShortCutString([keyCtrl, "W"]),
        disabled: false
      },
      {
        label: "Close All",
        messageType: nativeCommsBroadcastMessageTypes.FILE_CLOSE_ALL,
        disabled: false
      },
      {
        label: "Save",
        messageType: nativeCommsBroadcastMessageTypes.FILE_SAVE,
        shortcut: getShortCutString([keyCtrl, "S"]),
        disabled: false
      },
      {
        label: "Save As...",
        messageType: nativeCommsBroadcastMessageTypes.FILE_SAVE_AS,
        shortcut: getShortCutString([keyCtrl, keyShift, "S"]),
        disabled: false,
        hasSeparator: true
      },
      {
        label: "Import CSV or TSV...",
        messageType: nativeCommsBroadcastMessageTypes.FILE_IMPORT_CSV,
        disabled: false
      },
      {
        label: "Export",
        messageType: "Export",
        disabled: false,
        hasSeparator: true,
        children: exportMenu(state, disabledItems)
      },
      {
        label: "Convert Links to",
        messageType: "ConvertLinks",
        disabled: false,
        hasSeparator: true,
        children: convertLinksMenu(state, disabledItems)
      },
      {
        label: "Save as Template...",
        messageType: nativeCommsMessageTypes.SHOW_SAVE_TEMPLATE_MODAL,
        hasSeparator: true
      },
      {
        label: "Print",
        messageType: nativeCommsMessageTypes.FILE_PRINT,
        shortcut: getShortCutString([keyCtrl, "P"]),
        disabled: false,
        hasSeparator: true
      },
      {
        label: "Exit",
        messageType: nativeCommsBroadcastMessageTypes.FILE_EXIT,
        shortcut: null,
        disabled: false
      }
    ])
  ).map(item => toMenuItemRecord(item, disabledItems));
};
